import { getWorstCriticality } from 'src/shared/mappings/criticality';
import { TaskCriticalityEnum } from 'src/graphql/schema';
import { cn } from 'src/lib/utils';

import { useAppCard, canShowAttentionStrip } from '../model';

const CRITICALITY_CLASS_NAME: Record<TaskCriticalityEnum, string> = {
  [TaskCriticalityEnum.High]:
    'bg-[linear-gradient(90deg,transparent_0%,var(--color-destructive)_12%,var(--color-destructive)_88%,transparent_100%)]',
  [TaskCriticalityEnum.Medium]:
    'bg-[linear-gradient(90deg,transparent_0%,var(--color-orange-400)_12%,var(--color-orange-400)_88%,transparent_100%)]',
  [TaskCriticalityEnum.Low]:
    'bg-[linear-gradient(90deg,transparent_0%,var(--color-sky-500)_12%,var(--color-sky-500)_88%,transparent_100%)]',
};

const AttentionStrip = () => {
  const { data } = useAppCard();
  const worstCriticality = getWorstCriticality(data.taskCounts);

  if (!worstCriticality || !canShowAttentionStrip(data)) return null;

  return (
    <div
      data-testid="app-card-attention-strip"
      data-criticality={worstCriticality}
      aria-hidden="true"
      className={cn('absolute inset-x-0 top-0 h-0.75', CRITICALITY_CLASS_NAME[worstCriticality])}
    />
  );
};

export { AttentionStrip };
